export default {
  en: {
    'DROPDOWN_PH': 'Select'
  }
};